<template>
  <div class="download-app-qr-code" data-test-id="qr-container">
    <div class="download-app-qr-code__image" data-test-id="qr-code" />
    <div
      class="download-app-qr-code__border download-app-qr-code__border--lt"
    />
    <div
      class="download-app-qr-code__border download-app-qr-code__border--rt"
    />
    <div
      class="download-app-qr-code__border download-app-qr-code__border--rb"
    />
    <div
      class="download-app-qr-code__border download-app-qr-code__border--lb"
    />
  </div>
</template>

<style scoped lang="scss">
.download-app-qr-code {
  position: relative;
  align-self: center;
  width: 200px;
  height: 200px;
  padding: 20px;

  &__image {
    width: 160px;
    height: 160px;
    background-image: url('../../assets/app-qr.webp');
    background-position: center;
    border-style: none !important;
  }

  &__border {
    position: absolute;
    width: 53px;
    height: 53px;
    background-image: url('../../assets/qr-code-border.png');
    border-style: none !important;

    &--lt {
      top: 0;
      left: 0;
    }

    &--rt {
      top: 0;
      right: 0;
      transform: rotate(90deg);
    }

    &--rb {
      right: 0;
      bottom: 0;
      transform: rotate(180deg);
    }

    &--lb {
      bottom: 0;
      left: 0;
      transform: rotate(270deg);
    }
  }
}
</style>
